import 'whatwg-fetch';

import { SIMPLE, NO_CONTENT } from './constants';

const isFullfilled = {};

function callApi (endpoint, headers = {}, method = 'GET', body = '', signal) {
  const options = {
    credentials: 'include',
    method,
    headers,
    ...(signal && { signal })
  };
  if (body && !["GET", "HEAD"].includes(method)) {
    options.body = JSON.stringify(body);
  }
  return fetch(endpoint, options).then((response) => {
    /* 
      Different fetch implementations handle parsing JSON of a 204 response
      differently, so here we specifically catch the No Content/Empty response and
      return a resolved promise.
    */
    const { status } = response;
          
    if(isFullfilled[endpoint] === false) {
      isFullfilled[endpoint] = true;
    }

    if (response.status === NO_CONTENT) {
      return Promise.resolve({ status });
    }
    return response.text().then((jsonText) => {
      try {
          const json = JSON.parse(jsonText);
          if (!response.ok) {
            return Promise.reject({ json, status });
          }
          return { json, status };
      } catch (e) {
        if (jsonText === "" && response.ok) {
          return Promise.resolve({ status });
        }
        return Promise.reject({ json: jsonText, status });
      }
    });
  });
}

function createSimpleAPIMiddleware(processBody) {
  return ({ dispatch, getState }) => next => action => {
    const request = action[SIMPLE];

    if (typeof request === 'undefined') {
      return next(action);
    }

    const {
      payload = {},
      endpoint,
      types,
      context,
      method,
      body,
      headers,
      signal,
      waitForFullfill
    } = request;

    const [requestType, successType, failureType, abortType] = types;

    const actionWith = (data) => {
      const finalAction = { ...action, ...data };
    
      if (context) {
        finalAction.context = context;
      }
      delete finalAction[SIMPLE];
      return finalAction;
    };

    if (requestType) {
      next(actionWith({ type: requestType, payload }));
    }

    const getBody = () => {
      if(typeof processBody === 'function') {
        return processBody(request, getState);
      }
      return body;
    }

    // wait for fetch to be resolved/rejected before making another request
    if(waitForFullfill) {
      if (isFullfilled[endpoint] === false) {
        return;
      }
      isFullfilled[endpoint] = false;
    }

    return callApi(endpoint, headers, method, getBody(), signal).then(
      response => next(actionWith({
        response: response.json,
        status: response.status,
        type: successType,
        payload
      })),
      error => next(actionWith({
        status: error.status,
        type: error.name === "AbortError" && abortType ? abortType : failureType,
        error: error.json || error.title || error.message || 'Unexpected Error',
        payload
      }))
    );
  };
}

const simpleAPIMiddleware = createSimpleAPIMiddleware();

export default simpleAPIMiddleware;
export { createSimpleAPIMiddleware, callApi };
